import { type MailboxInfo, getAccountKeyForMailboxInfo } from 'owa-client-types';
import { getStore } from '../store/store';
import type { AsyncItemRegistry } from 'owa-copilot-async-chat-types';

export function getAsyncItemRegistry(mailboxInfo: MailboxInfo): AsyncItemRegistry | undefined {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    return getStore().registryByAccount.get(accountKey);
}
